import './index.css'
import type { CategoryBreakdownProps } from '../../types'
import { fmt } from '../../lib/format'
import { can } from '../../lib/features'

const PALETTE: string[] = ['#2F8F5C', '#E8A33D', '#6B9BD1', '#B43F30', '#1F6E43', '#557067', '#9B59B6', '#3498DB']
const OVER_COLOR = 'var(--expense-500)'

interface CatBarProps {
  name: string
  amount: number
  max: number
  color: string
  spending_limit?: number | null
  showLimits?: boolean
}

function CatBar({ name, amount, max, color, spending_limit, showLimits = true }: CatBarProps) {
  const hasLimit = showLimits && spending_limit != null && spending_limit > 0
  const isOver   = hasLimit && amount > spending_limit!

  if (hasLimit) {
    const fillPct    = Math.min((amount / spending_limit!) * 100, 100)
    const overAmount = isOver ? amount - spending_limit! : 0
    const overPct    = isOver ? Math.round((amount / spending_limit!) * 100) : 0
    const barColor   = isOver ? OVER_COLOR : color

    return (
      <div className={`bc-cat${isOver ? ' bc-cat--over' : ''}`}>
        <div className="bc-cat__row">
          <span className="bc-cat__name">{name}</span>
          <span className="bc-cat__amt">
            {fmt(amount)}
            <span className="bc-cat__limit-label"> / {fmt(spending_limit!)}</span>
          </span>
        </div>
        <div className="bc-cat__track">
          <div className="bc-cat__fill" style={{ width: fillPct + '%', background: barColor }} />
        </div>
        {isOver && (
          <div className="bc-cat__overage">
            +{fmt(overAmount)} ({overPct}%) — limite ultrapassado
          </div>
        )}
      </div>
    )
  }

  const pct = Math.max(4, (amount / max) * 100)
  return (
    <div className="bc-cat">
      <div className="bc-cat__row">
        <span className="bc-cat__name">{name}</span>
        <span className="bc-cat__amt">{fmt(amount)}</span>
      </div>
      <div className="bc-cat__track">
        <div className="bc-cat__fill" style={{ width: pct + '%', background: color }} />
      </div>
    </div>
  )
}

export default function CategoryBreakdown({ items, planTier = 'free' }: CategoryBreakdownProps) {
  const max = Math.max(...items.map(i => i.amount))
  const showLimits = can('categoryLimits', planTier) as boolean
  return (
    <div className="bc-card bc-breakdown">
      <h3 className="bc-list__title" style={{ padding: '16px 20px 8px', margin: 0 }}>
        Saídas por categoria
      </h3>
      <div className="bc-breakdown__body">
        {items.map((it, i) => (
          <CatBar key={it.id} {...it} max={max} color={PALETTE[i % PALETTE.length]} showLimits={showLimits} />
        ))}
      </div>
    </div>
  )
}
